{
  "phone-number-input": {
    "text": {
      "country-code": "Country code",
      "country-code-invalid": "Invalid",
      "country-code-required": "Required",
      "phone-nr": "Telephone number",
      "phone-nr-invalid": "Mobile number is invalid",
      "phone-nr-required": "Mobile number is required"
    }
  }
}
